import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import cls from 'classnames';
import Icon from '../Icon/Icon';
import Link, { NAV } from '../Link/Link';
import styles from './DocumentationLink.module.css';
function DocumentationLink(props) {
    const { href, className, iconOnly = false } = props;
    return (_jsxs(Link, { className: styles.documentationLink, href: href, external: true, appearance: NAV, children: [_jsx(Icon, { className: cls(styles.documentationLinkIcon, className), name: "help" }), _jsx("span", { children: !iconOnly && 'Help' })] }));
}
export default observer(DocumentationLink);
